import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle `
  body {
    font-family: "Inter", Arial, sans-serif;
    background: #fff;
    color: #111;
    margin: 0;
    padding: 0;
    overflow-y: auto;
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
    padding: 0;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  input, textarea {
    font-family: inherit;
    border: none;
    outline: none;
  }

  /* Ensure text and content are above graphics */
  .hero h1,
  .hero .intro,
  .hero-buttons,
  .projects-section h2,
  .project-card h3,
  .project-card p,
  .project-card .tag,
  .skills .skill span,
  .skills .bar,
  .experience h2,
  .exp-item,
  .contact-section h2,
  .contact-form,
  .social-icons {
    position: relative;
    z-index: 2;
  }

  /* Responsive design */
  @media (max-width: 900px) {
    body {
      padding: 16px 4vw 0 4vw;
    }
  }
`;
